/* eslint-disable camelcase */
import { defineRule } from 'vee-validate';
import { required, integer, confirmed, max_value, min_value, max, min } from '@vee-validate/rules';
import { AsYouType, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import { EMAIL, URL } from '@/constants/regularExpresions';
import { checkEmptyParams } from '@/utils/many';
import i18n from './i18n';

defineRule('required', (value, params, ctx) => {
  if (required(value, params, ctx) === true) return true;
  return i18n.t('validation.messages.required');
});
defineRule('integer', (value, params, ctx) => {
  if (integer(value, params, ctx) === true) return true;
  return i18n.t('validation.messages.integer');
});
defineRule('confirmed', confirmed);
defineRule('max_value', max_value);
defineRule('min_value', min_value);
defineRule('max', max);
defineRule('min', min);

defineRule('positive', value => {
  if (value === null || value === undefined || value === '') return true;
  const number = typeof value === 'number' ? value : Number(value);
  if (!Number.isNaN(number) && number >= 0) return true;
  return i18n.t('validation.messages.positive');
});

defineRule('url', value => {
  if (URL.test(value)) return true;
  return i18n.t('validation.messages.url');
});

defineRule('percent', value => {
  if (typeof value === 'number' && value >= 0 && value <= 100) return true;
  return i18n.t('validation.messages.percent');
});

defineRule('allLoaded', value => {
  if (value?.every(item => !item.isLoading)) return true;
  return i18n.t('validation.messages.wait_upload');
});

defineRule('email', value => {
  if (value === null || value === undefined || value === '') return true;
  if (EMAIL.test(value)) return true;
  return i18n.t('error.invalid_email');
});

defineRule('phone', value => {
  const phoneValidator = new AsYouType();
  phoneValidator.input(value);

  if (phoneValidator.isValid()) return true;

  const phoneCountry = phoneValidator.getCountry();
  const phoneExample = getExampleNumber(phoneCountry, examples)?.number;

  if (phoneExample) {
    return i18n.t('error.invalid_phone_with_example', { example: phoneExample });
  }

  return i18n.t('error.invalid_phone');
});

defineRule('password', value => {
  if (value?.length >= 8) return true;
  return i18n.t('error.min_characters');
});

defineRule('truethy', value => {
  if (value) return true;
  return i18n.t('validation.messages.required');
});

defineRule('manyRequired', value => {
  if (!checkEmptyParams(value)) return true;
  return i18n.t('validation.messages.required');
});

defineRule('requiredSelectManyRecipients', value => {
  if (!value || typeof value !== 'object') {
    return i18n.t('validation.messages.required');
  }

  const groups = ['projects', 'buildings', 'units', 'clients'];
  if (groups.every(group => !checkEmptyParams(value[group]))) return true;
  return i18n.t('validation.messages.required');
});

defineRule('6_decimal_places', value => {
  const parts = value.toString().split('.');
  if (parts.length === 1 || parts[1].length <= 6) return true;
  return i18n.t('validation.messages.6_decimal_places');
});
